<div class="info-bar-wrapper" [ngStyle]="getColor()">
    <div class="pe-2 left-side align-self-center">
        <div class="row">
            <div class="breadcrumbs align-self-center">
                <div
                    class="breadcrumb-chunk"
                    *ngFor="let breadcrumb of breadCrumbs; last as isLast"
                >
                    <a
                        class="breadcrumb-link gtm-collection-breadcrumb-link selenium-collection-breadcrumb-link"
                        [attr.data-gtmlabel]="breadcrumb.label"
                        [ngClass]="{ active: isLast }"
                        [routerLink]="breadcrumb.link"
                        [queryParams]="breadcrumb.params"
                    >
                        <span [innerHTML]="breadcrumb.label"></span>
                    </a>
                    <span *ngIf="!isLast" class="separator"> > </span>
                </div>
            </div>
        </div>
    </div>
    <div
        *ngIf="displayResourceDetails"
        class="collection-info-wrapper align-self-center g-0 right-side"
    >
        <div
            class="row-auto collection-info"
            [ngClass]="{
                'flex-nowrap align-items-center justify-content-lg-between': isStudentExperience,
                'w-100': isStudentExperience,
            }"
        >
            <div class="media-types-container" *ngIf="innerWidth > 991 && activeCollection.id">
                <div
                    class="g-0"
                    *ngIf="activeCollection.mediaTypesDisplay"
                    [ngClass]="{
                        'pe-lg-4 collection-resources': isStudentExperience,
                        'my-2': activeCollection.mediaTypesDisplay.length > 90,
                    }"
                >
                    <div class="in-collection">In This Collection:</div>
                    {{ activeCollection.mediaTypesDisplay }}
                    <ng-container *ngIf="activeCollection.resourceGradesDisplay">
                        for Grades {{ activeCollection.resourceGradesDisplay }}
                    </ng-container>
                    {{ activeCollection.resourceByLanguage }}
                </div>
            </div>
            <div class="select-gate col-lg-4 d-flex" *ngIf="isStudentExperience">
                Filtered by:
                <app-slide-toggle
                    *ngIf="gradesOptions.length"
                    class="ms-2"
                    [values]="gradesOptions"
                    (optionChangeEmitter)="changeGradeOptions($event)"
                >
                </app-slide-toggle>
            </div>
        </div>
    </div>
    <div>
        <app-search-collection-input
            class="search-collection-input"
            [placeholder]="'Search ' + activeCollection.title"
            [disableAutocomplete]="true"
            [collection]="getCollectionSlug()"
        ></app-search-collection-input>
    </div>
</div>
